 /**
  * Returns window.google object
  * If google maps was not loaded (typically due to network connection problems or any other problem), null is returned
  * @returns {Object|null}
  */
 const googleLibDiscover = () => {
    return window.google || null;
};

/**
 * 
 * @returns {Object|null}
 */
const goolgeLibMapsGet = () => {
    const googleLib = googleLibDiscover();
    return googleLib
        ? googleLib.maps
        : null;
};

export default googleLibDiscover;

export {
    goolgeLibMapsGet
};